// The marketing site publishes the tutorial in these locales; others read it in English.
export const TUTORIAL_LOCALES: readonly string[] = ["en", "de", "ja", "uk", "pl"];

/** The getting-started guide on the marketing site, in the UI language when it is published there. */
export const tutorialUrl = (language: string | undefined): string => {
  const code = language?.slice(0, 2) ?? "";
  const locale = TUTORIAL_LOCALES.includes(code) ? code : "en";
  return `https://timeplanned.com/${locale}/guides/getting-started`;
};
